const CV_DELIVERY_PINCODES = new Set([
  '411042', '411037', '411002', '411030', '411009', '411041', '411008', '411045', '411021', '411007', '411038',
  '400607', '400601', '400610', '400606', '400605', '411028', '411036', '411013', '411001', '411016', '411006', '411014', '411057',
]);

const CV_DELIVERY_STORAGE_KEY = 'cv-delivery-pincode';
const CV_DELIVERY_MESSAGE = 'Not delivering at your location currently';

function getPincode(value) {
  return String(value || '').match(/\b\d{6}\b/)?.[0] || '';
}

function getSelectedPincode() {
  try {
    return getPincode(window.localStorage.getItem(CV_DELIVERY_STORAGE_KEY));
  } catch (_) {
    return '';
  }
}

function isDeliverable(pincode) {
  return CV_DELIVERY_PINCODES.has(getPincode(pincode));
}

function savePincode(pincode) {
  const normalized = getPincode(pincode);
  if (!normalized) return false;

  try {
    window.localStorage.setItem(CV_DELIVERY_STORAGE_KEY, normalized);
  } catch (_) {
    // The current page still receives the delivery state when storage is unavailable.
  }

  document.dispatchEvent(new CustomEvent('cv:delivery-location-updated', {
    detail: { pincode: normalized, deliverable: isDeliverable(normalized) },
  }));
  return isDeliverable(normalized);
}

function currency(valueInCents) {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 })
    .format(valueInCents / 100);
}

function getPincodeDialog() {
  let dialog = document.getElementById('cv-delivery-pincode-dialog');
  if (dialog) return dialog;

  dialog = document.createElement('dialog');
  dialog.id = 'cv-delivery-pincode-dialog';
  dialog.innerHTML = `
    <form method="dialog" class="cv-delivery-dialog__panel" data-cv-delivery-dialog-form>
      <button class="cv-delivery-dialog__close" type="button" aria-label="Close">&times;</button>
      <h2>Check delivery availability</h2>
      <p>Enter your six-digit delivery pincode.</p>
      <label for="cv-delivery-dialog-input">Delivery pincode</label>
      <div class="cv-delivery-dialog__controls">
        <input id="cv-delivery-dialog-input" inputmode="numeric" autocomplete="postal-code" maxlength="6" pattern="[0-9]{6}" placeholder="Enter pincode">
        <button type="submit">Check</button>
      </div>
      <p class="cv-delivery-dialog__message" aria-live="polite"></p>
    </form>`;

  const style = document.createElement('style');
  style.textContent = `
    #cv-delivery-pincode-dialog { border: 0; border-radius: 8px; padding: 0; width: min(92vw, 420px); color: #222; box-shadow: 0 18px 60px rgb(0 0 0 / 28%); }
    #cv-delivery-pincode-dialog::backdrop { background: rgb(0 0 0 / 48%); }
    .cv-delivery-dialog__panel { position: relative; padding: 28px; }
    .cv-delivery-dialog__panel h2 { margin: 0 32px 8px 0; font-size: 22px; }
    .cv-delivery-dialog__panel p { margin: 0 0 18px; }
    .cv-delivery-dialog__panel label { display: block; margin-bottom: 7px; font-weight: 600; }
    .cv-delivery-dialog__controls { display: flex; gap: 8px; }
    .cv-delivery-dialog__controls input { width: 100%; min-width: 0; padding: 11px 12px; border: 1px solid #b5b5b5; border-radius: 5px; }
    .cv-delivery-dialog__controls button { border: 0; border-radius: 5px; background: #ea5a23; color: #fff; padding: 0 18px; cursor: pointer; font: inherit; font-weight: 600; }
    .cv-delivery-dialog__close { position: absolute; top: 10px; right: 12px; border: 0; background: transparent; color: #222; cursor: pointer; font-size: 28px; line-height: 1; }
    .cv-delivery-dialog__message { min-height: 22px; margin-top: 12px !important; }
  `;
  document.head.appendChild(style);
  document.body.appendChild(dialog);

  dialog.querySelector('.cv-delivery-dialog__close')?.addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-cv-delivery-dialog-form]')?.addEventListener('submit', (event) => {
    event.preventDefault();
    const input = dialog.querySelector('#cv-delivery-dialog-input');
    const message = dialog.querySelector('.cv-delivery-dialog__message');
    if (!(input instanceof HTMLInputElement) || !message) return;
    const pincode = getPincode(input.value);
    if (!pincode) {
      message.textContent = 'Enter a valid 6-digit pincode.';
      return;
    }
    const deliverable = savePincode(pincode);
    message.textContent = deliverable ? `Delivery available for ${pincode}.` : CV_DELIVERY_MESSAGE;
    if (deliverable) window.setTimeout(() => dialog.close(), 500);
  });

  return dialog;
}

function promptForPincode() {
  if (getSelectedPincode()) return;
  const dialog = getPincodeDialog();
  if (!dialog.open) dialog.showModal();
  window.setTimeout(() => dialog.querySelector('#cv-delivery-dialog-input')?.focus(), 0);
}

function updateCartDeliveryState() {
  const pincode = getSelectedPincode();
  const deliverable = isDeliverable(pincode);

  document.querySelectorAll('[data-cv-delivery-input]').forEach((input) => {
    if (input instanceof HTMLInputElement && input.value !== pincode) input.value = pincode;
  });

  document.querySelectorAll('[data-cv-delivery-summary]').forEach((summary) => {
    const subtotal = Number(summary.dataset.cartSubtotalCents || 0);
    const charge = subtotal > 49900 ? 0 : 4500;
    const value = summary.querySelector('.cart-totals__delivery-value');
    if (value) value.textContent = charge === 0 ? 'Free' : currency(charge);
  });

  document.querySelectorAll('[data-cv-delivery-status]').forEach((status) => {
    if (!pincode) {
      status.textContent = 'Enter your delivery pincode to continue.';
    } else if (deliverable) {
      status.textContent = `Delivery available for ${pincode}.`;
    } else {
      status.textContent = CV_DELIVERY_MESSAGE;
    }
  });

  document.querySelectorAll('#checkout, [data-testid="checkout-button"]').forEach((checkout) => {
    if (!(checkout instanceof HTMLButtonElement)) return;
    checkout.disabled = !deliverable;
    checkout.title = deliverable ? '' : (!pincode ? 'Enter a delivery pincode first.' : CV_DELIVERY_MESSAGE);
  });
}

function renderPincodeResult(input, pincode) {
  const modal = input.closest('[data-location-modal]');
  const results = modal?.querySelector('[data-location-results]');
  const empty = modal?.querySelector('[data-location-empty]');
  if (!results || !empty) return;

  const deliverable = isDeliverable(pincode);
  results.innerHTML = '';
  results.classList.add('active');
  empty.classList.remove('active');

  const suffix = Array.from(results.classList)
    .find((className) => className.startsWith('ai-header-location-results-'))
    ?.replace('ai-header-location-results-', '');
  const resultClass = suffix ? `ai-header-location-result-${suffix}` : '';
  const titleClass = suffix ? `ai-header-location-result-title-${suffix}` : '';
  const addressClass = suffix ? `ai-header-location-result-address-${suffix}` : '';

  const result = document.createElement('button');
  result.type = 'button';
  result.className = resultClass;
  result.innerHTML = `<span class="${titleClass}">${deliverable ? 'Delivery available' : CV_DELIVERY_MESSAGE}</span><span class="${addressClass}">${pincode}${deliverable ? ' - Delivery charge is free above Rs. 499; otherwise Rs. 45.' : ''}</span>`;
  result.addEventListener('click', () => {
    savePincode(pincode);
    const header = input.closest('ai-gen-header, [data-ai-header]');
    header?.querySelector('[data-location-city]')?.replaceChildren(document.createTextNode(pincode));
    header?.querySelector('[data-location-address]')?.replaceChildren(document.createTextNode(
      deliverable ? 'Delivery available' : CV_DELIVERY_MESSAGE,
    ));
    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  });
  results.appendChild(result);
}

document.addEventListener('input', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches('[data-location-search]')) return;

  const pincode = getPincode(input.value);
  if (!pincode) return;

  event.stopImmediatePropagation();
  renderPincodeResult(input, pincode);
}, true);

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-cv-delivery-form]')) return;

  event.preventDefault();
  const input = form.querySelector('[data-cv-delivery-input]');
  if (!(input instanceof HTMLInputElement)) return;

  const pincode = getPincode(input.value);
  if (!pincode) {
    input.setCustomValidity('Enter a valid 6-digit pincode.');
    input.reportValidity();
    return;
  }

  input.setCustomValidity('');
  savePincode(pincode);
}, true);

document.addEventListener('cv:delivery-location-updated', updateCartDeliveryState);
document.addEventListener('DOMContentLoaded', updateCartDeliveryState);
document.addEventListener('cart:updated', () => {
  updateCartDeliveryState();
  promptForPincode();
});

window.CVDelivery = { isDeliverable, savePincode, updateCartDeliveryState };
